module.exports = __webpack_public_path__ + "img/TPBANK.a61580ba.svg";